export enum MapIconTypes {
	Fish = 1,
	BoatLanding = 2,
	Reef = 3,
	Generic = 4,
	Buoy = 5,
}

